import styled from 'styled-components';

export const Container = styled.div`
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.grayLight};
  display: flex;
  flex-direction: ${(props) => props.direction || 'row'};
`;
